// vg-binding: P7.D-18
//
// apps/vendor/src/features/products/add/ApiInstructions.tsx
//
// Phase 7 Wave 8 Task 28 — API-key method instructions panel.
//
// API-key flow goes through the same POST /vendor/products endpoint
// but the caller authenticates with an API key (Bearer scope=
// products.write). Vendor sees the cURL example here; the real
// generate-API-key flow lands with Wave 13 settings.

import { useTranslation } from '../../../lib/i18n/index.js';

export function ApiInstructions(): JSX.Element {
  const { t } = useTranslation('products');
  return (
    <section
      data-testid="api-instructions"
      className="rounded-xl border border-pw-border bg-pw-bg p-4"
    >
      <h3 className="text-sm font-semibold text-pw-text">{t('apiInstructions.title')}</h3>
      <p className="mt-1 text-xs text-pw-text-muted">
        {t('apiInstructions.intro')}{' '}
        <strong>{t('apiInstructions.settingsLabel')}</strong>{' '}
        {t('apiInstructions.intro2')}{' '}
        <code>{t('apiInstructions.scopeLabel')}</code>
        {t('apiInstructions.intro3')}
      </p>
      <pre className="mt-3 overflow-x-auto rounded-md bg-pw-surface p-3 text-xs">
        {`curl -X POST https://api-v3.printway.work/api/v1/vendor/products \\
  -H "Content-Type: application/json" \\
  -H "Authorization: Bearer <YOUR_API_KEY>" \\
  -d '{
    "method": "api",
    "name": "Sample T-Shirt",
    "sku_prefix": "TSH",
    "product_type": "t-shirt",
    "processing_time_days": 3,
    "cost_price_cents": 1200,
    "capacity_per_day": 50,
    "weight_grams": 200,
    "dimensions": { "length": 30, "width": 20, "height": 2 },
    "warehouses_assigned": ["6612a8c4d3f2e10001b9a888"],
    "low_stock_threshold": 20,
    "variants": [
      { "size": "M", "color": "Black", "enabled": true,
        "cost_markup_cents": 0, "image_urls": [] }
    ]
  }'`}
      </pre>
      <p className="mt-3 text-xs text-pw-text-muted">
        {t('apiInstructions.responseHint')}{' '}
        <code>{`{ ok: true, data: { product_id, state: 'pending', ... } }`}</code>.
        {' '}{t('apiInstructions.pendingHint')}{' '}
        <strong>{t('apiInstructions.pendingLabel')}</strong>{' '}
        {t('apiInstructions.pendingHint2')}
      </p>
    </section>
  );
}

export default ApiInstructions;
